<template>
  <PageLayout>
    <!-- Webview shell: the core talks directly to the native bridge host. -->
    <ShoppingAssistantChat
      :can-resume-latest
      :entry-point
      :entry-source
      :initial-chat-id
      :is-seeded-launch
      :page-context
      :seeded-message
    />
  </PageLayout>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'
import { computed, provide } from 'vue'

import PageLayout from '../../components/PageLayout/PageLayout.vue'
import ShoppingAssistantChat from '../../components/ShoppingAssistantChat/ShoppingAssistantChat.vue'
import {
  type EntryPoint,
  useShoppingAssistantContext,
} from '../../composables/useShoppingAssistantContext'
import { SHOPPING_ASSISTANT_HOST_KEY } from '../../composables/useShoppingAssistantHost.injection-key'
import { useWebviewShoppingAssistantHost } from '../../composables/useWebviewShoppingAssistantHost'
import { SHOPPING_ASSISTANT_NEW_WEBVIEW } from '../../routes.constants'

const route = useRoute()

// The explicit "new chat" route always starts fresh — never resume the latest
// chat there, even though it carries no chatId and no seed (a route change
// between route records always remounts this component, so this is stable per
// mount).
const canResumeLatest = computed(
  () => route.name !== SHOPPING_ASSISTANT_NEW_WEBVIEW,
)

// The native webview shell derives the chat context from the route (deep-link
// query params, chatId path param) and frames the route-agnostic chat core.
const { pageContext, seededMessage, entrySource, isSeededLaunch } =
  useShoppingAssistantContext()

// We do not use the entryPoint returned by useShoppingAssistantContext as webview have a specific behavior
const entryPoint = computed<EntryPoint>(() =>
  pageContext.value?.type === 'product_page' ? 'product_page' : 'search',
)

const initialChatId =
  typeof route.params.chatId === 'string' ? route.params.chatId : null

provide(SHOPPING_ASSISTANT_HOST_KEY, useWebviewShoppingAssistantHost())
</script>
